export default __webpack_public_path__ + "static/media/vacation.2f8ea5fa.svg";